import { render } from "./InputTextArea.vue?vue&type=template&id=906e0b3c&scoped=true"
import script from "./InputTextArea.vue?vue&type=script&lang=js"
export * from "./InputTextArea.vue?vue&type=script&lang=js"

import "./InputTextArea.vue?vue&type=style&index=0&id=906e0b3c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-906e0b3c"

export default script